import css from './image/css-removebg-preview.png';
import git from './image/git-removebg-preview.png';
import motion from './image/motion-removebg-preview.png';
import nextjs from './image/nextjs-removebg-preview.png';
import javascript from './image/javascript-removebg-preview.png';
import materail from './image/materail-removebg-preview.png';
import firebase from './image/firebase-removebg-preview.png';
import html from './image/html-removebg-preview.png';
import daisy from './image/daisy-removebg-preview.png';
import mongodb from './image/mongodb-removebg-preview.png';
import node from './image/node-removebg-preview.png';
import prisma from './image/prisma.png';
import react from './image/react-removebg-preview.png';
import tailwind from './image/tailwind-removebg-preview.png';

const product = [
  {
    logo: html,
    title: 'HTML',
  },
  {
    logo: css,
    title: 'css',
  },
  {
    logo: javascript,
    title: 'JavaScript',
  },
  {
    logo: react,
    title: 'React Js',
  },
  {
    logo: tailwind,
    title: 'Tailwind Css',
  },
  {
    logo: nextjs,
    title: 'Next Js',
  },
  {
    logo: git,
    title: 'Git-Hub',
  },
  {
    logo: mongodb,
    title: 'MongoDB',
  },
  {
    logo: firebase,
    title: 'FireBase',
  },
  {
    logo: materail,
    title: 'Material',
  },
  {
    logo: motion,
    title: 'Framer-Motion',
  },
  {
    logo: prisma,
    title: 'Prisma DB',
  },
  {
    logo: daisy,
    title: 'Daisy Ui',
  },
  {
    logo: node,
    title: 'Node Js',
  },
];

export default product;
